import "./Permission.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import StepIndicator from "./StepIndicator";
import Support from "../../contact-popup-module/Support";
import NetworkSpeed from "../internet-strength/NetworkSpeed";
import InternetSignal from "../internet-strength/InternetSignal";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import axios from "axios";

const Permission = () => {

	const [cameraPermission, setCameraPermission] = useState(false);
	const [locationPermission, setLocationPermission] = useState(false);
	const [openPermissionDialog, setOpenPermissionDialog] = useState(false);
	const [openLocPermissionDialog, setOpenLocPermissionDialog] = useState(false);
	const [openCamPermissionDialog, setOpenCamPermissionDialog] = useState(false);
	const [openAudioPermissionDialog, setOpenAudioPermissionDialog] = useState(false);
	const [locationError, setLocationError] = useState(null);
	const [dialogWidth, setDialogWidth] = useState("29vw");
	const [dialogText, setDialogText] = useState("0.9rem");
	const [locationPermStatus, setLocationPermStatus] = useState("denied");
	const [proceedStatus, setProceedStatus] = useState(false);
	const [cameraPermStatus, setCameraPermStatus] = useState();
	const [configDataStatus, setConfigDataStatus] = useState(false);
	const [audioPermission, setAudioPermission] = useState(false);
	const [audioPermStatus, setAudioPermStatus] = useState();
	const [deviceType, setDeviceType] = useState("Unknown Device");
	const [retryCount, setRetryCount] = useState(0); // Mock device type for demonstration
	const navigate = useNavigate();
	const { audit_id } = useParams();
	const [openDialogLowInternet, setOpenDialogLowInternet] = useState(true);
	const [speed, setSpeed] = useState(null);
	const [isWebView, setIsWebView] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const camera_gif = `${process.env.PUBLIC_URL}/inspection-images/camera.gif`;
	const location_gif = `${process.env
		.PUBLIC_URL}/inspection-images/location.gif`;
	const location_icon = `${process.env.PUBLIC_URL}/custom-icons/location.png`;
	const camera_icon = `${process.env.PUBLIC_URL}/custom-icons/camera.png`;
	const audio_icon = `${process.env.PUBLIC_URL}/custom-icons/audio.png`;
	const tick_icon = `${process.env.PUBLIC_URL}/custom-icons/tick.png`;
	const query_icon = `${process.env.PUBLIC_URL}/custom-icons/query.png`;
	const back_icon = `${process.env.PUBLIC_URL}/custom-icons/back-icon.png`;
	const uid = useSelector((state) => state.imagesStore.user_userID);
	console.log("permission", uid);
	useEffect(() => {
		// Detect if running in WebView
		const checkWebView = () => {
			const userAgent = window.navigator.userAgent.toLowerCase();
			return userAgent.includes('wv') || // Android WebView
				userAgent.includes('fb') || // Facebook WebView
				window.webkit?.messageHandlers; // iOS WebView
		};

		setIsWebView(checkWebView());
	}, []);

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth <= 400) {
				setDialogWidth("85vw");
			} else if (window.innerWidth <= 475) {
				setDialogWidth("74vw");
			} else if (window.innerWidth <= 550) {
			} else if (window.innerWidth <= 575) {
				setDialogText("0.6rem");
				setDialogWidth("64vw");
			} else if (window.innerWidth <= 650) {
				setDialogWidth("60vw");
			} else if (window.innerWidth <= 775) {
				setDialogWidth("57vw");
			} else if (window.innerWidth <= 875) {
				setDialogWidth("55vw");
			} else if (window.innerWidth <= 1000) {
				setDialogWidth("48vw");
			} else if (window.innerWidth <= 1100) {
				setDialogWidth("45vw");
				setDialogText("0.8rem");
			} else if (window.innerWidth <= 1300) {
				setDialogWidth("40vw");
			} else {
				setDialogWidth("35vw");
			}
		};

		handleResize();

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);
	console.log(deviceType, "deviceType")
	// useEffect(() => {
	// 	const checkPermissions = async () => {
	// 		console.log('Checking permissions...');

	// 		try {
	// 			// Camera Permission
	// 			if ('permissions' in navigator) {
	// 				const camResult = await navigator.permissions.query({ name: 'camera' });
	// 				console.log('Camera permission status:', camResult.state);
	// 				setCameraPermStatus(camResult.state);
	// 				setCameraPermission(camResult.state === 'granted');
	// 			}

	// 			// Audio Permission
	// 			const audioResult = await navigator.permissions.query({ name: 'microphone' });
	// 			console.log('Audio permission status:', audioResult.state);
	// 			setAudioPermStatus(audioResult.state);
	// 			setAudioPermission(audioResult.state === 'granted');

	// 			// Location Permission - try different methods
	// 			console.log('Checking location permission...');

	// 			// First try permissions API
	// 			try {
	// 				const locResult = await navigator.permissions.query({ name: 'geolocation' });
	// 				console.log('Location permission query result:', locResult.state);

	// 				if (locResult.state === 'granted') {
	// 					setLocationPermStatus('granted');
	// 					setLocationPermission(true);
	// 				} else if (locResult.state === 'prompt') {
	// 					// If prompt, request permission
	// 					requestLocationPermission();
	// 				} else {
	// 					setLocationPermStatus('denied');
	// 				}
	// 			} catch (error) {
	// 				console.warn('Location permission query failed:', error);
	// 				// If permissions query fails, try direct geolocation request
	// 				if (locationPermStatus === 'granted') {
	// 					requestLocationPermission();
	// 				}
	// 			}
	// 		} catch (error) {
	// 			console.error('Permission check error:', error);
	// 		}
	// 	};

	// 	checkPermissions();
	// }, []);
	useEffect(() => {
		const checkPermissions = async () => {
			console.log('Checking permissions...');

			const requestWithRetry = async (requestFunction, setStatusFunction, setPermissionFunction, permissionType) => {
				let permissionGranted = false;

				while (!permissionGranted) {
					try {
						// Query permission
						const result = await navigator.permissions.query({ name: permissionType });
						console.log(`${permissionType} permission status:`, result.state);

						if (result.state === 'granted') {
							setStatusFunction('granted');
							setPermissionFunction(true);
							permissionGranted = true; // Stop retrying
						} else if (result.state === 'prompt' || result.state === 'denied') {
							// Call the specific request function for permission
							await requestFunction();
						}

						// Delay before retrying, only if not yet granted
						if (!permissionGranted) await new Promise(resolve => setTimeout(resolve, 10000));
					} catch (error) {
						console.error(`${permissionType} permission request failed:`, error);
						await new Promise(resolve => setTimeout(resolve, 5000));
					}
				}
			};

			try {

				await requestWithRetry(requestCameraPermission, setCameraPermStatus, setCameraPermission, 'camera');

				await requestWithRetry(requestAudioPermission, setAudioPermStatus, setAudioPermission, 'microphone');

				await requestWithRetry(requestLocationPermission, setLocationPermStatus, setLocationPermission, 'geolocation');
			} catch (error) {
				console.error('Error in permission check process:', error);
			}
		};

		checkPermissions();
	}, []);
	const [auditData, setAuditData] = useState(null);
	useEffect(() => {
		const fetchDetails = async () => {
			try {
				const response = await axios.get(`/create_audit/get_audit_details/${audit_id}`);
				setConfigDataStatus(true)
				setAuditData(response.data);
				console.log("200", response.data);
				localStorage.setItem('inspectionConfiguration', JSON.stringify(response.data));

			} catch (error) {
				console.error("Error fetching audit details:", error);
			}
		};

		if (audit_id) {
			fetchDetails();
		}
	}, [audit_id]);
	console.log("audioPermStatus", audioPermStatus, "137")
	useEffect(() => {
		console.log("219",configDataStatus);
		
		const newProceedStatus =
			cameraPermStatus === 'granted' &&
			// audioPermStatus === 'granted' &&
			locationPermStatus === 'granted' && configDataStatus;

		console.log('Permission status updated:', {
			camera: cameraPermStatus,
			audio: audioPermStatus,
			location: locationPermStatus,
			canProceed: newProceedStatus
		});

		setProceedStatus(newProceedStatus);
	}, [cameraPermStatus, locationPermStatus, audioPermStatus,configDataStatus]);
	//   useEffect(() => {
	//     setProceedStatus(
	//       cameraPermStatus === 'granted' && 
	//       locationPermStatus === 'granted' && 
	//       audioPermStatus === 'granted'
	//     );
	//   }, [cameraPermStatus, locationPermStatus, audioPermStatus]);

	// console.log(proceedStatus,"106");

	console.log("locationPermStatus : ", locationPermStatus, "  cameraPermStatus: ", cameraPermStatus, "97");
	// const requestCameraPermission = () => {
	// 	navigator.mediaDevices
	// 		.getUserMedia({ video: true })
	// 		.then(() => {
	// 			setCameraPermission(true);
	// 			setOpenCamPermissionDialog(false);
	// 		})
	// 		.catch(() => alert("Camera permission denied"));
	// };
	const requestCameraPermission = async () => {
		try {
			const stream = await navigator.mediaDevices.getUserMedia({
				video: {
					facingMode: 'environment' // Prefer rear camera
				}
			});

			// Success - stop stream and update states
			stream.getTracks().forEach(track => track.stop());
			setCameraPermission(true);
			setCameraPermStatus('granted');
		} catch (error) {
			console.error('Camera permission error:', error);
			setCameraPermStatus('denied');

			// Specific error handling for common WebView issues
			if (error.name === 'NotAllowedError') {
				alert('Please enable camera access in your device settings');
			} else if (error.name === 'NotFoundError') {
				alert('No camera found on device');
			} else {
				alert('Camera access failed. Please check device settings.');
			}
		}
	};
	const requestLocationPermission = async () => {
		console.log('Requesting location permission...');

		// Check if geolocation is available
		if (!navigator.geolocation) {
			console.error('Geolocation not supported');
			setLocationError('Geolocation not supported');
			setLocationPermStatus('denied');
			return;
		}
		const options = {
			enableHighAccuracy: true,
			timeout: 30000,
			maximumAge: 0
		};

		const successCallback = (position) => {
			console.log('Location success:', {
				latitude: position.coords.latitude,
				longitude: position.coords.longitude,
				accuracy: position.coords.accuracy
			});

			setLocationPermission(true);
			setLocationPermStatus('granted');
			setLocationError(null);
		};
		const errorCallback = (error) => {
			console.error('Location error:', {
				code: error.code,
				message: error.message
			});

			setLocationPermStatus('denied');

			let errorMessage = '';
			switch (error.code) {
				case error.PERMISSION_DENIED:
					errorMessage = 'Location permission denied';
					// Try watchPosition as a fallback
					tryWatchPosition();
					break;
				case error.POSITION_UNAVAILABLE:
					errorMessage = 'Location information unavailable';
					break;
				case error.TIMEOUT:
					errorMessage = 'Location request timed out';
					break;
				default:
					errorMessage = 'Unknown location error';
			}

			setLocationError(errorMessage);
		};
		const tryWatchPosition = () => {
			console.log('Trying watchPosition as fallback...');
			const watchId = navigator.geolocation.watchPosition(
				(position) => {
					console.log('WatchPosition success');
					successCallback(position);
					navigator.geolocation.clearWatch(watchId);
				},
				(error) => {
					console.error('WatchPosition error:', error);
					setLocationError('Location access failed in watchPosition');
				},
				options
			);
		};

		// Add try-catch for additional error handling
		try {
			// Check if geolocation is available
			if (!navigator.geolocation) {
				alert('Geolocation is not supported by this browser/WebView. Please update your app or use a different browser.');
				return;
			}

			// Log attempt for debugging
			console.log('Requesting location permission, attempt:', retryCount + 1);

			// Request location
			navigator.geolocation.getCurrentPosition(
				successCallback,
				errorCallback,
				options
			);
		} catch (e) {
			console.error('Geolocation request failed:', e);
			alert('Unable to access location services. Please check app permissions and try again.');
		}
	};
	const testSpeed = async () => {

		const fileSize = 5 * 1024 * 1024; // 5MB file
		const testFile = 'https://speed.cloudflare.com/__down?bytes=5000000'; // Cloudflare test file

		const startTime = new Date().getTime();

		try {
			const response = await fetch(testFile);
			await response.arrayBuffer();

			const endTime = new Date().getTime();
			const durationInSeconds = (endTime - startTime) / 1000;
			const speedMbps = (fileSize / durationInSeconds / (1024 * 1024) * 8).toFixed(2);

			setSpeed(speedMbps);
		} catch (error) {
			console.error('Speed test failed:', error);
			setSpeed('Error');
		}

	};
	useEffect(() => {
		const intervalId = setInterval(testSpeed, 2000);
		return () => {
			clearInterval(intervalId);
		};
	}, []);
	const network = `${process.env.PUBLIC_URL}/custom-icons/network.png`;
	// const requestAudioPermission = async () => {
	// 	try {
	// 		// Request audio permission
	// 		const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
	// 		console.log('Audio permission granted');
	// 		// Stop the stream immediately to avoid using unnecessary resources
	// 		stream.getTracks().forEach(track => track.stop());
	// 		// Handle the granted permission status
	// 		setAudioPermStatus('granted');
	// 		setOpenLocPermissionDialog(false);
	// 	} catch (error) {
	// 		// console.error('Audio permission denied', error);
	// 		// // Handle the denied permission status
	// 		// setAudioPermStatus('denied');
	// 		// setOpenLocPermissionDialog(true);
	// 		if(audioPermStatus!=='granted'){
	// 		requestAudioPermission()}
	// 	}
	// };
	const requestAudioPermission = async () => {
		try {
			// Check if mediaDevices API is available
			if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
				throw new Error('Media devices API not available');
			}

			// Request audio permission with constraints
			const stream = await navigator.mediaDevices.getUserMedia({
				audio: true,
				video: false
			});

			console.log('Audio permission granted');
			// Stop the stream immediately
			stream.getTracks().forEach(track => track.stop());

			setAudioPermStatus('granted');
			setErrorMessage('');

			return true;

		} catch (error) {
			console.error('Microphone access error:', error);

			let message = '';

			if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
				message = 'Microphone permission was denied. Please enable it in your settings.';
				setAudioPermStatus('denied');
			} else if (error.name === 'NotFoundError') {
				message = 'No microphone device found.';
			} else if (error.name === 'NotReadableError') {
				message = 'Microphone is already in use or not functioning properly.';
			} else if (error.name === 'SecurityError') {
				message = isWebView ?
					'WebView permissions not properly configured. Please check app settings.' :
					'Security error accessing microphone.';
			} else {
				message = `Error accessing microphone: ${error.message}`;
			}

			setErrorMessage(message);
			return false;
		}
	};

	const checkPermission = async () => {
		try {
			// Check if permissions API is available
			if (navigator.permissions && navigator.permissions.query) {
				const result = await navigator.permissions.query({ name: 'microphone' });
				setAudioPermStatus(result.state);

				// Listen for permission changes
				result.onchange = () => {
					setAudioPermStatus(result.state);
				};
			}
		} catch (error) {
			console.error('Error checking permission:', error);
		}
	};

	useEffect(() => {
		checkPermission();
	}, []);

	const handleRetryAudio = () => {
		requestAudioPermission();
	};

	const handleRequestPermission = () => {
		requestAudioPermission();
	};
	const handleLocationRetry = () => {
		console.log('Retrying location permission...');
		setLocationError(null);
		requestLocationPermission();
	};


	// const handleProceed = () => {
	//     if (cameraPermission && locationPermission) {
	//         navigate(`/audit/${audit_id}`);
	//     } else {
	//         setOpenPermissionDialog(true);
	//     }
	// };
	const handleRetry = (type) => {
		console.log(type)
		if (type === "location" && !locationPermission) {
			setOpenLocPermissionDialog(true);
			requestAudioPermission();
		}
		else if (type === "camera" && !cameraPermission) {
			setOpenCamPermissionDialog(true);
		}
		else if (type === "audio" && !audioPermission) {
			setOpenAudioPermissionDialog(true);
			requestAudioPermission();
		}
		// if (!locationPermission && !cameraPermission && !audioPermission) {
		//   setOpenPermissionDialog(true);
		// } 
		// else if (!locationPermission) {
		//   setOpenLocPermissionDialog(true);
		// } else if (!cameraPermission) {
		//   setOpenCamPermissionDialog(true);
		// }
		// else if(!audioPermission){
		//   setOpenAudioPermissionDialog(true)
		// }
	};
	const handleDialogClose = event => {

		setOpenDialogLowInternet(false);
	};

	const handleButtonClick = async () => {
		  // Check if the user is on a mobile device
  const isMobile = window.innerWidth <= 768;
  if (!isMobile) {
    alert("You can use this app only on mobile");
    return;
  }
		if ("geolocation" in navigator) {
			try {
				if (proceedStatus) {
					navigate(`/audit/photo/${audit_id}`);
				} else {
					if (locationPermStatus !== 'granted') {
						handleLocationRetry();
					}
				}
				if (locationPermission && cameraPermission) {
					navigator.geolocation.getCurrentPosition(async position => {
						// const { latitude, longitude } = position.coords;
						// const audit = await getLocation(latitude, longitude);
						//   dispatch(setAuditID(audit_id));
						// navigate("/landing-page");
						navigate(`/audit/photo/${audit_id}`);
					});
				} else if (!locationPermission && !cameraPermission && !audioPermission) {
					setOpenPermissionDialog(true);
				} else if (!locationPermission) {
					requestLocationPermission();
					setOpenLocPermissionDialog(true);
				} else if (!cameraPermission) {
					setOpenCamPermissionDialog(true);
				}
				else if (!audioPermission) {
					setOpenAudioPermissionDialog(true)
				}
			} catch (error) {
				console.error("Error querying location permission:", error);
				// Handle the error appropriately
			}
		} else {
		}
	};
	console.log(proceedStatus, "proceed status");
	const clearImageCache = async () => {
		try {
			const cacheName = 'image-cache';

			// Check if the cache exists
			const cacheExists = await caches.has(cacheName);

			if (cacheExists) {
				// Delete the entire cache
				await caches.delete(cacheName);
				console.log(`${cacheName} cleared successfully.`);
			} else {
				console.log(`${cacheName} does not exist.`);
			}
		} catch (error) {
			console.error('Error clearing the cache:', error);
		}
	};
	useEffect(() => {
		const clearBrowserCache = async () => {
			await clearImageCache();
		}
		clearBrowserCache()
	}, [])
	useEffect(() => {
		const askper = async () => {
			await requestAudioPermission();
			await requestCameraPermission();
			await requestLocationPermission();
		}
		askper()
	}, [])
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleGoBack = () => {
		console.log("620");
		
		navigate(-1);
	};

	return (
		<div
			className="loc-cam-permission-parent"  >
			{/* <img src={query_icon} className="question-div" /> */}
			<img
				src={back_icon}
				alt="back icon"
				className="back-div-perms"
				onClick={handleGoBack}
			/>
			{speed !== null && <InternetSignal signalStrength={speed} />}
			<img
				src={query_icon}
				alt="Query Icon"
				className="question-div"
				onClick={handleClickOpen}
			/>

			{/* Support Popup */}
			<Dialog open={open} onClose={handleClose} className="support-popup-dialog">
				<DialogContent className="support-popup-content">
					<Support />
					<button onClick={handleClose} className="close-btn">close</button>
				</DialogContent>
			</Dialog>
			<div className="permissions-page">
				<StepIndicator stepNumber={2} />
				<p className="allow-permission-step-indicator">All permissions {locationPermStatus}</p>
				<p className="allow-permission-div">Allow permission on your device</p>
				<div className="permission-card-parent">
					{/* camera */}
					<div
						className="permission-card"

					>
						<div
							style={{
								display: "flex",
								alignItems: "flex-end",
								justifyContent: "flex-start",
								gap: "0.3rem"
							}}
						>
							<img
								src={camera_icon}
								style={{ width: "20px", height: "19px" }}
							/>
							<p
								style={{
									fontFamily: "Barlow Condensed",
									fontSize: "18px",
									fontWeight: "600",
									color: ' #000000DE'
								}}
							>
								Camera
							</p>
						</div>

						<p
							style={{
								fontFamily: "'Montserrat', sans-serif",
								fontSize: "14px",
								// color: "black",
								fontWeight: "400"
							}}
						>
							For capturing the car
						</p>

						{cameraPermStatus === "granted"
							? <div
								style={{
									fontFamily: "'Montserrat', sans-serif",
									fontSize: "14px",
									color: "#ff007f",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									gap: "0.3rem",
									position: "absolute",
									bottom: "20px",
									right: "10px"
								}}
							>
								<span>
									<img src={tick_icon} style={{ width: "14px" }} />
								</span>
								<span>Allowed</span>
							</div>
							: cameraPermStatus === "denied"
								? <div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: "0.5rem",
										position: "absolute",
										bottom: "20px",
										right: "10px"
									}}
								>
									{/* <span style={{ fontSize: "10px", color: "red" }}>
										Access denied
									</span> */}
									<button
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											gap: "0.2rem",
											border: "1.5px solid #FF0083",
											padding: "0.1rem 0.5rem",
											backgroundColor: "white",
											borderRadius: "4px",
											fontSize: "0.9rem"
										}}
										onClick={() => handleRetry("camera")}

									>
										{/* <img src={reload} style={{ width: "1rem", height: "1rem" }}></img> */}
										<p
											style={{
												fontSize: "1rem",
												fontFamily: "'Montserrat', sans-serif",
												color: "#FF0083",
												padding: "0.3rem",
												cursor: "pointer"
											}}
										>
											Retry
										</p>
									</button>
								</div>
								: cameraPermStatus === "prompt"
									? <button
										className="allow-button"
										onClick={requestCameraPermission}
										style={{
											position: "absolute",
											bottom: "10px",
											right: "10px",
											backgroundColor: "#ff007f"
										}}
										disabled={
											cameraPermStatus === "prompt"
												? false
												: cameraPermStatus === "granted"
													? true
													: cameraPermStatus === "denied" ? true : true
										}
									>
										{cameraPermStatus === "prompt"
											? "Allow"
											: cameraPermStatus === "granted"
												? "Allowed"
												: cameraPermStatus === "denied" ? "Denied" : ""}
									</button>
									: <p />}
					</div>
					{/* location */}
					<div
						className="permission-card"

					>
						<div
							style={{
								display: "flex",
								alignItems: "flex-end",
								justifyContent: "flex-start",
								gap: "0.3rem"
							}}
						>
							<img
								src={location_icon}
								style={{ width: "20px", height: "20px" }}
							/>
							<p
								style={{
									fontFamily: "Barlow Condensed",
									fontSize: "18px",
									fontWeight: "600",
									color: ' #000000DE'
								}}
							>
								Location
							</p>
						</div>
						<p
							style={{
								fontFamily: "'Montserrat', sans-serif",
								fontSize: "14px",
								fontWeight: "400"
							}}
						>
							For the location of the inspection
						</p>
						{locationPermStatus === "granted"
							? <div
								style={{
									fontFamily: "'Montserrat', sans-serif",
									fontSize: "14px",
									color: "#ff007f",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									gap: "0.3rem",
									position: "absolute",
									bottom: "20px",
									right: "10px"
								}}
							>
								<span>
									<img src={tick_icon} style={{ width: "14px" }} />
								</span>
								<span>Allowed</span>
							</div>
							: locationPermStatus === "denied"
								? <div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: "0.5rem",
										position: "absolute",
										bottom: "20px",
										right: "10px"
									}}
								>
									{/* <span style={{ fontSize: "10px", color: "red" }}>
										Access denied
									</span> */}
									<button
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											gap: "0.2rem",
											border: "1.5px solid #FF0083",
											padding: "0.1rem 0.5rem",
											backgroundColor: "white",
											borderRadius: "4px",
											fontSize: "0.9rem"
										}}
										onClick={() => handleRetry("location")}

									>
										{/* <img src={reload} style={{ width: "1rem", height: "1rem" }}></img> */}
										<p
											style={{
												fontSize: "1rem",
												fontFamily: "'Montserrat', sans-serif",
												color: "#FF0083",
												padding: "0.3rem",
												cursor: "pointer"
											}}
										>
											Retry
										</p>
									</button>
								</div>
								: locationPermStatus === "prompt"
									? <button
										className="allow-button"
										onClick={requestLocationPermission}
										style={{
											position: "absolute",
											bottom: "10px",
											right: "10px",
											backgroundColor:
												locationPermStatus === "granted" ||
													locationPermStatus === "denied"
													? "lightgray"
													: "#ff007f"
										}}
										disabled={
											locationPermStatus === "prompt"
												? false
												: locationPermStatus === "granted"
													? true
													: locationPermStatus === "denied" ? true : true
										}
									>
										{locationPermStatus === "prompt"
											? "Allow"
											: locationPermStatus === "granted"
												? "Allowed"
												: locationPermStatus === "denied" ? "Denied" : ""}
									</button>
									: <p />}
					</div>
					{/* audio */}
					<div className="permission-card">
						<div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-start", gap: "0.3rem" }}>
							<img src={audio_icon} style={{ width: "20px", height: "19px" }} />
							<p style={{ fontFamily: "Barlow Condensed", fontSize: "18px", fontWeight: "600", color: ' #000000DE' }}>Audio</p>
						</div>

						<p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", fontWeight: "400" }}>
							For video inspection
						</p>

						{audioPermStatus === "granted"
							? <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", color: "#ff007f", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.3rem", position: "absolute", bottom: "20px", right: "10px" }}>
								<span><img src={tick_icon} style={{ width: "14px" }} /></span>
								<span>Allowed</span>
							</div>
							: audioPermStatus === "denied"
								? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", position: "absolute", bottom: "20px", right: "10px" }}>
									{/* <span style={{ fontSize: "10px", color: "red" }}>Access denied</span> */}
									<button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FF0083", padding: "0.1rem 0.5rem", backgroundColor: "white", borderRadius: "4px", fontSize: "0.9rem" }} onClick={() => handleRetry("audio")}
									>
										<p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FF0083", padding: "0.3rem", cursor: "pointer" }} >Retry</p>
									</button>
								</div>
								: audioPermStatus === "prompt"
									? <button className="allow-button" onClick={handleRequestPermission} style={{ position: "absolute", bottom: "10px", right: "10px", backgroundColor: "#ff007f" }} disabled={audioPermStatus !== "prompt"}>
										{audioPermStatus === "prompt" ? "Allow" : audioPermStatus === "granted" ? "Allowed" : audioPermStatus === "denied" ? "Denied" : "Retry"}
									</button>
									: <p />}
					</div>
				</div>

				<button
					// disabled={!proceedStatus}
					onClick={handleButtonClick}
					className="proceed-button"
					style={{
						backgroundColor: proceedStatus ? "#FF0083" : "#dcdcdc",
						color: proceedStatus ? "#ffffff" : "#0000003D",
						pointerEvents: proceedStatus ? "auto" : "none"
					}}
				>
					Proceed
				</button>

				{/* 1 */}
				<Dialog
					open={openPermissionDialog}
					sx={{ zIndex: "99999999999999999999" }}
					// onClose={handleDialogClose}
					maxWidth="150vw"
					maxHeight="lg"
					PaperProps={{
						style: {
							width: dialogWidth,
							padding: "0.5rem 0.5rem",
							paddingBottom: "0.5rem",
							borderRadius: "4px",
							boxSizing: "border-box"
						}
					}}
				>
					<DialogTitle
						style={{
							display: 'flex',
							fontSize: dialogText,
							textAlign: "center",
							color: "black",
							paddingBottom: "0.1rem ",
							fontWeight: "bold",
							fontFamily: 'Barlow Condensed',
						}}
					>
						{/* <img
              src={camera_icon}
              style={{ width: "20px", height: "20px", marginRight: "5px" }}
            /><h6> */}
						Enable Location, Camera, Microphone Permissions
						{/* </h6> */}
					</DialogTitle>
					<DialogContent style={{ padding: "0.5rem" }}>
						<div className="enable-permissions">
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-evenly"
								}}
							>
								{/* <img src={location_gif} style={{ width: "5rem" }} />
                <img src={camera_gif} style={{ width: "5rem" }} /> */}
							</div>
							{deviceType === "Laptop" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>
										1. Open info icon in the top header to view site settings.
									</span>
									<span>2. Go to site settings.</span>
									<span>3. Set camera, microphone & location preferences to "ALLOW"</span>
									{/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
								</div>}
							{deviceType === "iPhone" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Location Services.</span>
									<span>3. Set location as "ON".</span>
									<span>
										4. Below view safari/chrome -- "Allow only while using the
										app"{" "}
									</span>
									<span>5. Search Camera.</span>
									<span>
										6. Set camera as "ON" for the browser use are using.
									</span>
									<span>
										7. Set microphone as "ON" for the browser use are using.
									</span>
									{/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
								</div>}
							{deviceType === "Android" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px", }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Location.</span>
									<span>3. Set location as "ON".</span>
									<span>4. Then, search "chrome" browser.</span>
									<span>
										5. In chrome -- permissions -- Location -- "Allow only while
										using the app"{" "}
									</span>
									<span>6. Search Camera.</span>
									<span>
										7. Set camera as "ON" for the browser use are using.
									</span>
									<span>
										8. Set microphone as "ON" for the browser use are using.
									</span>
									{/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
								</div>}
							{deviceType === "Unknown Device" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Location.</span>
									<span>3. Set location as "ON".</span>
									<span>4. Then, search "internet" browser.</span>
									<span>
										5. In setting -- permissions -- Location -- "Allow only while
										using the app"{" "}
									</span>
									<span>6. Search Camera.</span>
									<span>
										7. Set camera as "ON" for the browser use are using.
									</span>
									{/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic",
                      fontFamily: 'Montserrat'
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
								</div>}
							<div style={{
								display: 'flex',
								justifyContent: 'flex-end', // Aligns the button to the right
								marginTop: '10px' // Adds some space above the button
							}}>
								<Button
									variant="outlined"
									className="close-permissions-dialog"
									style={{
										alignSelf: 'flex-end', // Align the button to the end vertically
										padding: '6px 20px', // Optional: Adjust padding for better look
										fontSize: '14px',
										background: '#ff0083',
										color: '#ffffff',
										border: 'none'
									}}
									onClick={() => {
										setOpenPermissionDialog(false);
									}}
								>
									OK
								</Button>
							</div>

						</div>
						{/* </MuiAlert> */}
					</DialogContent>
				</Dialog>

				{/* 2 */}
				<Dialog
					open={openLocPermissionDialog}
					sx={{ zIndex: "99999999999999999999" }}
					// onClose={handleDialogClose}
					maxWidth="150vw"
					maxHeight="lg"
					PaperProps={{
						style: {
							width: dialogWidth,
							padding: "0.5rem 0.5rem",
							paddingBottom: "0.5rem",
							borderRadius: "4px",
							boxSizing: "border-box"
						}
					}}
				>
					<DialogTitle
						style={{
							display: 'flex',
							alignItems: "center",
							justifyContent: "flex-start",
							textAlign: "center",
							color: "black",

							fontWeight: "bold",
							fontFamily: 'Barlow Condensed',
							fontSize: "1rem",
							padding: "1rem 0.5rem 0rem 0.5rem",
						}}
					>
						<img
							src={location_icon}
							style={{ width: "20px", height: "20px", marginRight: "5px" }}
						/>
						<span>
							Enable Location permissions
						</span>
					</DialogTitle>
					<DialogContent style={{ padding: "0.5rem" }}>
						<div className="enable-permissions">
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-evenly"
								}}
							>
								{/* <img src={location_gif} style={{ width: "5rem" }} /> */}
							</div>

							{deviceType === "Laptop" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>
										1. Open info icon in the top header to view site settings.
									</span>
									<span>2. Go to site settings.</span>
									<span>3. Set location preference to "ALLOW"</span>
									{/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
								</div>}
							{deviceType === "iPhone" &&
								<div style={{ listStyleType: "decimal", textAlign: "justify", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Location Services.</span>
									<span>3. Set location as "ON".</span>
									<span>
										4. Below view safari/chrome -- "Allow only while using the
										app"{" "}
									</span>
									{/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
								</div>}
							{deviceType === "Android" &&
								<div style={{ listStyleType: "decimal", textAlign: "justify", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Location.</span>
									<span>3. Set location as "ON".</span>
									<span>4. Then, search "chrome" browser.</span>
									<span>
										5. In chrome -- permissions -- Location -- "Allow only while
										using the app"{" "}
									</span>
									{/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
								</div>}
							{deviceType === "Unknown Device" &&
								<div style={{ listStyleType: "decimal", textAlign: "justify", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Location.</span>
									<span>3. Set location as "ON".</span>
									<span>4. Then, search "internet" browser.</span>
									<span>
										5. In setting -- permissions -- Location -- "Allow only while
										using the app"{" "}
									</span>
									{/* <span
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      fontStyle: "italic"
                    }}
                  >
                    --- Reload the page ---
                  </span> */}
								</div>}

							<div style={{
								display: 'flex',
								justifyContent: 'flex-end', // Aligns the button to the right
								marginTop: '10px' // Adds some space above the button
							}}>
								<Button
									variant="outlined"
									className="close-permissions-dialog"
									style={{
										alignSelf: 'flex-end', // Align the button to the end vertically
										padding: '6px 20px', // Optional: Adjust padding for better look
										fontSize: '14px',
										background: '#ff0083',
										color: '#ffffff',
										border: 'none'
									}}
									onClick={() => {
										setOpenLocPermissionDialog(false);
									}}
								>
									OK
								</Button>
							</div>
						</div>
						{/* </MuiAlert> */}
					</DialogContent>
				</Dialog>
				{/* 3 */}
				<Dialog
					open={openCamPermissionDialog}
					sx={{ zIndex: "99999999999999999999" }}
					// onClose={handleDialogClose}

					maxWidth="150vw"
					maxHeight="lg"
					PaperProps={{
						style: {
							width: dialogWidth,
							padding: "0.5rem 0.5rem",
							paddingBottom: "0.5rem",
							borderRadius: "4px",
							boxSizing: "border-box"
						}
					}}
				>
					<DialogTitle
						style={{
							display: 'flex',
							alignItems: "center",
							justifyContent: "flex-start",
							textAlign: "center",
							color: "black",

							fontWeight: "bold",
							fontFamily: 'Barlow Condensed',
							fontSize: "1rem",
							padding: "1rem 0.5rem 0rem 0.5rem",
						}}
					>
						<img
							src={camera_icon}
							style={{ width: "20px", height: "20px", marginRight: "5px" }}
						/>
						<span style={{}}>
							Enable Camera permissions
						</span>
					</DialogTitle>
					<DialogContent style={{ padding: "0.5rem" }}>
						<div className="enable-permissions">
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-evenly"
								}}
							>
								{/* <img src={camera_gif} style={{ width: "5rem" }} /> */}
							</div>
							{deviceType === "Laptop" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>
										1. Open info icon in the top header to view site settings.
									</span>
									<span>2. Go to site settings.</span>
									<span>3. Set camera preference to "ALLOW"</span>
									{/* <span>--- Reload the page ---</span> */}
								</div>}
							{deviceType === "iPhone" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Camera.</span>
									<span>
										3. Set camera as "ON" for the browser use are using.
									</span>
									{/* <span>--- Reload the page ---</span> */}
								</div>}
							{deviceType === "Android" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Camera.</span>
									<span>
										3. Set camera as "ON" for the browser use are using.
									</span>
									{/* <span>--- Reload the page ---</span> */}
								</div>}
							{deviceType === "Unknown Device" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search Camera.</span>
									<span>
										3. Set camera as "ON" for the browser use are using.
									</span>
									{/* <span>--- Reload the page ---</span> */}
								</div>}

							{/* <Button
                variant="outlined"
                className="close-permissions-dialog"
                onClick={() => {
                  setOpenCamPermissionDialog(false);
                }}
              >
                OK
              </Button> */}
							<div style={{
								display: 'flex',
								justifyContent: 'flex-end', // Aligns the button to the right
								marginTop: '10px' // Adds some space above the button
							}}>
								<Button
									variant="outlined"
									className="close-permissions-dialog"
									style={{
										alignSelf: 'flex-end', // Align the button to the end vertically
										padding: '6px 20px', // Optional: Adjust padding for better look
										fontSize: '14px',
										background: '#ff0083',
										color: '#ffffff',
										border: 'none'
									}}
									onClick={() => {
										setOpenCamPermissionDialog(false);
									}}
								>
									OK
								</Button>
							</div>
						</div>
						{/* </MuiAlert> */}
					</DialogContent>
				</Dialog>
				{/* 4 */}
				<Dialog
					open={openAudioPermissionDialog}
					sx={{ zIndex: "99999999999999999999" }}
					// onClose={handleDialogClose}

					maxWidth="150vw"
					maxHeight="lg"
					PaperProps={{
						style: {
							width: dialogWidth,
							padding: "0.5rem 0.5rem",
							paddingBottom: "0.5rem",
							borderRadius: "4px",
							boxSizing: "border-box"
						}
					}}
				>
					<DialogTitle
						style={{
							display: 'flex',
							alignItems: "center",
							justifyContent: "flex-start",
							textAlign: "center",
							color: "black",

							fontWeight: "bold",
							fontFamily: 'Barlow Condensed',
							fontSize: "1rem",
							padding: "1rem 0.5rem 0rem 0.5rem",
						}}
					>
						<img
							src={audio_icon}
							style={{ width: "20px", height: "20px", marginRight: "5px" }}
						/>
						<span>
							Enable Microphone permissions
						</span>
					</DialogTitle>
					<DialogContent style={{ padding: "0.5rem" }}>
						<div className="enable-permissions">
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-evenly"
								}}
							>
								{/* <img src={camera_gif} style={{ width: "5rem" }} /> */}
							</div>
							{deviceType === "Laptop" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>
										1. Open info icon in the top header to view site settings.
									</span>
									<span>2. Go to site settings.</span>
									<span>3. Set microphone preference to "ALLOW"</span>
									{/* <span>--- Reload the page ---</span> */}
								</div>}
							{deviceType === "iPhone" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search microphone.</span>
									<span>
										3. Set microphone as "ON" for the browser use are using.
									</span>
									{/* <span>--- Reload the page ---</span> */}
								</div>}
							{deviceType === "Android" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search microphone.</span>
									<span>
										3. Set microphone as "ON" for the browser use are using.
									</span>
									{/* <span>--- Reload the page ---</span> */}
								</div>}
							{deviceType === "Unknown Device" &&
								<div style={{ listStyleType: "decimal", fontFamily: 'Montserrat', fontSize: "15px" }}>
									<span>1. Open Settings app.</span>
									<span>2. Search microphone.</span>
									<span>
										3. Set microphone as "ON" for the browser use are using.
									</span>
									{/* <span>--- Reload the page ---</span> */}
								</div>}

							{/* <Button
                variant="outlined"
                className="close-permissions-dialog"
                onClick={() => {
                  setOpenCamPermissionDialog(false);
                }}
              >
                OK
              </Button> */}
							<div style={{
								display: 'flex',
								justifyContent: 'flex-end', // Aligns the button to the right
								marginTop: '10px' // Adds some space above the button
							}}>
								<Button
									variant="outlined"
									className="close-permissions-dialog"
									style={{
										alignSelf: 'flex-end', // Align the button to the end vertically
										padding: '6px 20px', // Optional: Adjust padding for better look
										fontSize: '14px',
										background: '#ff0083',
										color: '#ffffff',
										border: 'none'
									}}
									onClick={() => {
										setOpenAudioPermissionDialog(false);
									}}
								>
									OK
								</Button>
							</div>
						</div>
						{/* </MuiAlert> */}
					</DialogContent>
				</Dialog>
				{speed && speed < 5 && <Dialog
					open={openDialogLowInternet}
					onClose={handleDialogClose}
					maxWidth="150vw"
					maxHeight="lg"
					PaperProps={{
						style: {
							width: dialogWidth,
							// padding: "1.5rem 1rem",
							// paddingBottom: "0.5rem",
							borderRadius: "4px",
							margin: "0px",
							height: "120px",
							zIndex: "999999"
						},
					}}
				>


					<DialogTitle
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-start",

							gap: "0.3rem",
							fontSize: "1.3rem",
							textAlign: "center",
							color: "black",
							padding: "1rem 0.9rem",
							fontWeight: "600",
							fontFamily: 'Barlow Condensed',
						}}
					>



						<>
							<img src={network} style={{ width: "9%" }} />
							<span >Low internet connection</span>
						</>

					</DialogTitle>
					<div style={{ padding: "0 1rem", fontFamily: "'Montserrat', sans-serif", }} >
						Please switch to a more stable connection to continue seamlessly
					</div>
					<IconButton
						aria-label="close"
						onClick={handleDialogClose}
						sx={{
							position: "absolute",
							right: 7,
							top: 10,
							color: "black",
						}}
					>
						<CloseIcon />
					</IconButton>
				</Dialog>}
			</div>
		</div >
	);
};

export default Permission;
